export default __webpack_public_path__ + "static/media/590.42bd8b40.png";